import id from './id.js'
import initialState from './initial-state.js'
import selectorDefinitions from './selectors/index.js'

const favoriteAssetsReduxDefinition = {
  id,
  type: 'redux-module',
  initialState,
  eventReducers: {
    favoriteAssets: (state, data) => ({ ...state, loaded: true, data }),
  },
  selectorDefinitions,
}

export default favoriteAssetsReduxDefinition
